const REVIEW_ENUM = {
	BY_PRODUCT: 'PRODUCT',
	BY_PROFILE: 'BY_PROFILE',
	BY_STORE: 'BY_STORE',
	BY_SHOPPER: 'BY_SHOPPER'
};

module.exports = REVIEW_ENUM;


/** WEBPACK FOOTER **
 ** ./wowapp/src/shop/components/customer-reviews/enums/review-factory-enum.js
 **/